import { render, staticRenderFns } from "./coachTopicManage.vue?vue&type=template&id=0a38f69e&scoped=true"
import script from "./coachTopicManage.vue?vue&type=script&lang=ts"
export * from "./coachTopicManage.vue?vue&type=script&lang=ts"
import style0 from "./coachTopicManage.vue?vue&type=style&index=0&id=0a38f69e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38f69e",
  null
  
)

export default component.exports